
$(function() {
'use strict';

$('.radios--input').click(function(){
let jan = $(this).data("jan");
$('#jan').text(jan);
});

});

var sliderOpt = {
	arrows: true,
	dots: true,
	autoplay: false,
	adaptiveHeight:true,
	speed: 500,
	fade:true,
	slidesToShow: 1,
	slidesToScroll: 1,
	cssEase: 'ease-out',
	lazyLoad: 'progressive',
	pauseOnFocus: false,
	pauseOnHover: false,
	prevArrow: '<div class="prev-arrow"></div>',
	nextArrow: '<div class="next-arrow"></div>',
	customPaging: function (slick, index) {
		var targetImage = slick.$slides.eq(index).find('img').attr('data-thumb');
      //console.log(targetImage);
		targetImage = targetImage.replace( '{width}', '200');
		return '<img src=" ' + targetImage + ' "/>';
	}
};

var slider = $('.slider');
slider.on('init', function (event, slick) {
	moveArrow();
});
slider.slick(sliderOpt);

slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
	moveArrow();
});

function moveArrow() {
	var h = $('.slick-current').find('img').height() / 2 - 8;
	if (h < 50) {
		h = $('.product-media--featured').height() / 2 - 8;
		if (h < 50) {
			$('.slick-arrow').css({ 'top': '50%' });
		}
	}
	$('.slick-arrow').css({ 'top': h + 'px' });
}